export default "__VITE_ASSET__DaAeJaWx__"